import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="notFound__container">
    <h1 className="notFound__404">404</h1>
    <p className="notFound__text">
      Sorry, but we can&apos;t seem to find the
      <br />
      page you&apos;re looking for.
    </p>
    <p className="notFound__text">Here are some helpful links:</p>
    <div style={{ textAlign: 'center' }}>
      <Link to="/">Dashboard</Link>
      <a
        className="notFound__link"
        href={process.env.REACT_APP_GROW_WEBSITE_URL}
        target="blank"
      >
        AGIGrow.com
      </a>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js